/**
 * Landing page family interactions.
 */
(function($, window, document) {
  'use strict';

  const config = window.pcmLandingpageFamily || {};

  function unlockShowcase() {
    $('.lp-family-showcase--locked').each(function() {
      const $showcase = $(this);

      $showcase
        .removeClass('lp-family-showcase--locked')
        .addClass('lp-family-showcase--unlocked');

      $showcase.find('.lp-family-showcase__unlock-track').remove();
      $showcase.find('.lp-family-showcase__inner').removeAttr('aria-hidden inert');
    });

    if (config.unlockedScrollCueText) {
      $('.lp-family-scroll-cue__text').text(config.unlockedScrollCueText);
    }

    document.body.classList.add('landingpage-family--unlocked');
  }

  // isRetry: already retried once with a fresh nonce, so don't loop.
  function loadDesignGrid($grid, industry, isRetry) {
    if (!config.ajaxUrl || $grid.data('lpFamilyLoading')) {
      return;
    }

    $grid.data('lpFamilyLoading', true).addClass('lp-family-showcase__grid--loading');

    $.ajax({
      type: 'POST',
      url: config.ajaxUrl,
      dataType: 'json',
      data: {
        action: 'pcm_lp_family_designs',
        nonce: config.designsNonce,
        post_id: $grid.data('postId'),
        posts_per_page: $grid.data('postsPerPage'),
        industry: industry
      }
    }).done(function(response) {
      if (response && response.success && typeof response.data.html === 'string') {
        $grid.html(response.data.html);
        return;
      }

      // The page's nonce can expire before the cached page does: get a live
      // one and retry once. Async, so .always() has cleared the loading flag
      // by the time the retry runs.
      if (!isRetry && response && response.data && response.data.message === 'Invalid nonce' && window.pcmFetchFreshNonce) {
        window.pcmFetchFreshNonce('pcm_lp_family_designs').then(function(nonce) {
          config.designsNonce = nonce;
          loadDesignGrid($grid, industry, true);
        });
      }
    }).always(function() {
      $grid.removeData('lpFamilyLoading').removeClass('lp-family-showcase__grid--loading');
    });
  }

  // Production's gated landing pages hide the Zendesk launcher (see
  // pcm_lp_hides_chat_launcher()), so their faux chat is the way in - and it
  // nudged. Once the gallery unlocked it typed a greeting and followed up a
  // minute later; each time the visitor closed the real chat window it came
  // back with another prompt. On a phone it was a blinking bubble in the
  // corner that slid up as a chat bar; tapping the bar opened the real
  // chat. The wording is on the widget (partials/landingpage-family-chat-sidebar.php).
  const CHAT_FOLLOW_UP_DELAY = 60000;
  const phoneWidth = window.matchMedia('(max-width: 767px)');

  function chatAvailable() {
    return typeof window.pcmChatAvailable === 'function'
      ? window.pcmChatAvailable()
      : document.documentElement.classList.contains('pcm-chat-available');
  }

  function chatStarted() {
    const classes = document.documentElement.classList;

    return classes.contains('pcm-chat-sent') || classes.contains('pcm-chat-started');
  }

  function typeChatMessage($chat, message) {
    if (!message) {
      return;
    }

    $chat.removeClass('modal-fauxchat--sent modal-fauxchat--closed').css('display', '').addClass('is-open');

    if (typeof window.modalChatText === 'function') {
      window.modalChatText($chat, message);
    } else {
      $chat.find('.modal-fauxchat-window-message-text').first().text(message);
    }
  }

  function initLandingChat() {
    const $sidebarChats = $('[data-pcm-lp-chat="sidebar"]');
    let followUpTimer = null;
    let unlocked = false;
    let greeted = false;

    if (!$sidebarChats.length) {
      return;
    }

    function nudge(messageKey, followUpKey, unlessChatStarted) {
      window.clearTimeout(followUpTimer);

      if (!chatAvailable() || (unlessChatStarted && chatStarted())) {
        return;
      }

      if (messageKey === 'chatUnlocked') {
        greeted = true;
      }

      $sidebarChats.each(function() {
        typeChatMessage($(this), $(this).data(messageKey));
      });

      followUpTimer = window.setTimeout(function() {
        if (!chatAvailable() || (unlessChatStarted && chatStarted())
          || document.documentElement.classList.contains('pcm-zopim-window-open')) {
          return;
        }

        $sidebarChats.each(function() {
          typeChatMessage($(this), $(this).data(followUpKey));
        });
      }, CHAT_FOLLOW_UP_DELAY);
    }

    function onUnlocked() {
      if (unlocked) {
        return;
      }

      unlocked = true;

      // The phone bubble and bar are position: fixed, which the locked
      // gallery's blur would pin inside the gallery instead of the screen,
      // so they move out to <body> - production moved its chat too.
      if (phoneWidth.matches) {
        $sidebarChats.closest('.fauxchat-wrap').appendTo(document.body);
      }

      document.documentElement.classList.add('pcm-lp-chat-ready');

      window.setTimeout(function() {
        if (!greeted) {
          nudge('chatUnlocked', 'chatUnlockedFollowUp', true);
        }
      }, 1000);
    }

    // A visitor who already sent a message from the form's chat step is
    // talking to someone; production skipped the greeting then.
    if ($('form[data-lp-family-unlock="true"]').length && !document.body.classList.contains('landingpage-family--unlocked')) {
      $(document).on('pcm:formComplete formComplete', 'form[data-lp-family-unlock="true"]', onUnlocked);
    } else {
      onUnlocked();
    }

    $(document).on('pcm:zopimWindowShow', function() {
      window.clearTimeout(followUpTimer);
      $sidebarChats.removeClass('is-open');
    });

    $(document).on('pcm:zopimWindowHide', function() {
      $sidebarChats.find('.modal-fauxchat-textarea').val('');

      if (unlocked) {
        nudge('chatClosed', 'chatClosedFollowUp', false);
      }
    });

    // A page left open across its legacy invitation hours can change
    // availability. The all-day LPs keep their invitation when agents are
    // offline; Zendesk's actual status is shown separately in the card.
    $(document).on('pcm:chatAvailability', function(event) {
      const detail = event.originalEvent && event.originalEvent.detail;

      if (detail && detail.available) {
        if (unlocked && !greeted) {
          nudge('chatUnlocked', 'chatUnlockedFollowUp', true);
        }
        return;
      }

      window.clearTimeout(followUpTimer);
      $sidebarChats.removeClass('is-open');
    });
  }

  $(function() {
    initLandingChat();

    // The unlock form is multistep (email, phone, address, chat), so this
    // only fires once the visitor has finished or skipped every step. Nothing
    // is remembered: like production, the next load - a refresh included -
    // is locked again. Not even pcm_lead_token, which pcm-forms.js stores
    // after any successful step of any form on the site.
    $(document).on('pcm:formComplete formComplete', 'form[data-lp-family-unlock="true"]', function() {
      unlockShowcase();
    });

    // Sending from the chat step finishes the form, which unlocks the page.
    $(document).on('pcm:fauxChatSent', 'form[data-lp-family-unlock="true"] [data-pcm-lp-chat="step"]', function() {
      const $form = $(this).closest('form');

      if (window.PCMForms) {
        window.PCMForms.skipStep($form.attr('id'));
      }
    });

    $(document).on('pcm:stepChange', 'form[data-lp-family-unlock="true"]', function(event, data) {
      const $form = $(this);
      const $step = $form.find('.step:visible').first();

      if ($step.hasClass('step-chat')) {
        // Production only offers the chat step on desktop - on a phone the
        // address step is the last one - and within its legacy invitation hours.
        if (phoneWidth.matches || !chatAvailable()) {
          if (window.PCMForms) {
            window.PCMForms.skipStep($form.attr('id'));
          }
          return;
        }

        const $chat = $step.find('[data-pcm-lp-chat="step"]').first();

        if ($chat.length) {
          typeChatMessage($chat, $chat.data('chatQuestion'));
          $chat.find('.modal-fauxchat-textarea').first().trigger('focus');
          return;
        }
      }

      // The step the visitor just submitted is gone, so keep focus in the
      // card instead of letting it drop back to the top of the page.
      if (data && data.direction === 'forward') {
        $step.find('input:not([type="hidden"]), button').first().trigger('focus');
      }
    });

    $(document).on('change', '[data-lp-family-industry-filter]', function() {
      const $select = $(this);
      const $grid = $select.closest('.lp-family-showcase').find('[data-lp-family-designs-grid]').first();

      if ($grid.length) {
        loadDesignGrid($grid, $select.val());
      }
    });
  });
})(jQuery, window, document);
